import React, { useState } from 'react';
import ConfirmActionPopover from '../../Shared/Popovers/ConfirmActionPopover';
import { BillInfoPopover } from './BillInfoPopover';

interface RelatedBillPillProps {
  relatedBill: {
    id: string;
    abbrTitle: string;
  };
  isTracked: boolean;
}

export const RelatedBillPill: React.FC<RelatedBillPillProps> = ({
  relatedBill,
  isTracked,
}) => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <ConfirmActionPopover
      closePopup={() => setShowPopover(false)}
      content={<BillInfoPopover billId={relatedBill.id} />}
      hideCloseIcon
      onClickOutside={() => setShowPopover(false)}
      show={showPopover}
      target={
        <div
          className="related-bill-pill"
          id={`bill-pill-${relatedBill.id}`}
          onClick={() => setShowPopover(true)}
        >
          <div className={`pill-dot ${isTracked ? 'active' : 'inactive'}`} />
          {relatedBill.abbrTitle}
        </div>
      }
      toggleCallback={() => setShowPopover(!showPopover)}
    />
  );
};

export default RelatedBillPill;
